<div
  [ngClass]="cssClass()"
  class="pssr-status-badge">
  @if (useIcon() && !isDeleted()) {
    <span class="pssr-status-icon">
      @switch (status()) {
        @case (PSSRStatus.Draft) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <path
              d="M14.17,5.242,12.868,3.9,11.955,3l-.779.785L3.235,11.841,3,12.063v3.021H6.269l1.289-1.3L14.3,6.954l.779-.792ZM5.732,13.781H4.289V12.6l6-6.042,1.3,1.343Zm6.807-6.887L11.2,5.551l.859-.866,1.3,1.343Z"
              transform="translate(-1.041 -1.041)"
              fill="currentColor" />
          </svg>
        }
        @case (PSSRStatus.Initiated) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <g transform="translate(-35.006 24.396)">
              <path
                d="M45.672-21.4V-22.73H40.338V-21.4H37.672v11.334H48.338V-21.4Zm-4,0h2.666v1.334H41.672Zm5.333,10.139h-8v-8.8h1.333v1.333h5.334v-1.333h1.333Z"
                fill="currentColor" />
              <rect
                width="5.333"
                height="1.333"
                transform="translate(40.338 -17.397)"
                fill="currentColor" />
              <rect
                width="2.667"
                height="1.333"
                transform="translate(40.338 -14.73)"
                fill="currentColor" />
            </g>
          </svg>
        }
        @case (PSSRStatus.InProgress) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <path
              d="M8.959,3A5.88,5.88,0,0,0,4.986,4.569V3.662H3.662v3.31H6.973V5.648H5.781a4.635,4.635,0,1,1,3.178,7.944,4.549,4.549,0,0,1-2.88-1.013A4.687,4.687,0,0,1,4.324,8.958H3A5.992,5.992,0,1,0,8.959,3Z"
              transform="translate(-0.959 -0.959)"
              fill="currentColor" />
            <path
              d="M11,8v3.273l1.361,1.361.749.742.96-.96-1.708-1.708V8Z"
              transform="translate(-3.701 -2.721)"
              fill="currentColor" />
          </svg>
        }
        @case (PSSRStatus.Completed) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <g transform="translate(-35.006 24.063)">
              <path
                d="M45.672-21.4V-22.73H40.338V-21.4H37.672v11.334h6v-1.2H39.005v-8.8h1.333v1.333h5.334v-1.333h1.333V-15.4h1.333v-6Zm-1.334,1.334H41.672V-21.4h2.666Z"
                fill="currentColor" />
              <rect
                width="5.333"
                height="1.333"
                transform="translate(40.338 -17.397)"
                fill="currentColor" />
              <rect
                width="2.667"
                height="1.333"
                transform="translate(40.338 -14.73)"
                fill="currentColor" />
              <path
                d="M5.34,9,4,7.68l.353-.355.985.973L7.648,6,8,6.355Z"
                transform="translate(40.338 -20.063)"
                stroke="currentColor"
                stroke-width="0.5" />
            </g>
          </svg>
        }
        @case (PSSRStatus.PendingApproval) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.213"
            height="16"
            viewBox="0 0 14.213 16">
            <path
              d="M147.284,43.3h-2.37a.593.593,0,0,1,0-1.185h1.778V39.157a.593.593,0,0,1,1.185,0v3.556a.593.593,0,0,1-.593.593Zm-.58,4.4c-.013-4.993,7.1-4.993,7.084-.526C153.8,52.194,146.715,52.194,146.7,47.705Zm3.541.85a.346.346,0,1,0,.341.344A.346.346,0,0,0,150.245,48.556Zm.285-2.675c-.093-.192-.4-.166-.531-.03-.17.181-.094.546-.08.765l.074,1.109h0a1.05,1.05,0,0,0,.069.321.2.2,0,0,0,.35,0,.874.874,0,0,0,.069-.313l.1-1.141a1.373,1.373,0,0,0-.051-.707Zm-5,1.934a5.528,5.528,0,0,1-4-4.51h1.024a.593.593,0,0,0,0-1.185h-1.132a5.652,5.652,0,0,1,5.28-5.9V37.4a.593.593,0,0,0,1.185,0V36.222a5.589,5.589,0,0,1,5.333,5.9l-.009,0h-1.185a.575.575,0,0,0-.545.758,4.712,4.712,0,0,1,1.068.427h.546c-.02.1-.053.2-.077.3a4.767,4.767,0,0,1,.995.963c1.37-4.147-.866-9.561-6.717-9.561-8.955,0-9.442,12.673-1.481,14.081a4.706,4.706,0,0,1-.279-1.275Z"
              transform="translate(-140.179 -35.009)"
              fill="currentColor" />
          </svg>
        }
        @case (PSSRStatus.Approved) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <path
              d="M8.667,2a6.667,6.667,0,1,0,6.667,6.667A6.667,6.667,0,0,0,8.667,2Zm0,11.953a5.287,5.287,0,1,1,5.287-5.287,5.287,5.287,0,0,1-5.287,5.287Z"
              transform="translate(-0.666 -0.666)"
              fill="currentColor" />
            <path
              d="M9.32,11.687,8.213,10.58l-.973.973L8.347,12.66H8.34l.98.98,4.667-4.667L13.007,8Z"
              transform="translate(-2.414 -2.666)"
              fill="currentColor" />
          </svg>
        }
        @case (PSSRStatus.Closed) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16">
            <path
              d="M132.867,56.168a6.765,6.765,0,1,0,6.767,6.769A6.779,6.779,0,0,0,132.867,56.168Zm0,1.411a5.342,5.342,0,0,1,3.318,1.146l-7.547,7.505a5.362,5.362,0,0,1,4.229-8.652Zm4.3,2.157a5.363,5.363,0,0,1-7.525,7.485Z"
              transform="translate(-125.1 -54.933)"
              fill="currentColor" />
          </svg>
        }
      }
    </span>
  }
  {{ translationKey() | translate }}
</div>
